import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSiteData, waLink } from "../../lib/hooks";
import { UtensilsCrossed, CalendarHeart, MessageSquare } from "lucide-react";

export function WhatsAppButton() {
  const s = useSiteData();
  return (
    <a
      href={waLink(s)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      className="fixed z-40 bottom-24 lg:bottom-8 right-5 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-black/30 border border-white/30 transition-transform group-hover:scale-110">
        <i className="fa-brands fa-whatsapp text-2xl" />
      </span>
    </a>
  );
}

export function MobileBottomNav() {
  const s = useSiteData();
  const loc = useLocation();
  const items = [
    { icon: UtensilsCrossed, label: "MENU", to: "/menus" },
    { icon: CalendarHeart, label: "EVENTS", to: "/experiences" },
    { icon: MessageSquare, label: "ENQUIRE", to: "/contact" },
  ];
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 lg:hidden glass border-t border-gold/25" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-4">
        {items.slice(0, 1).map((it) => <Item key={it.to} it={it} loc={loc} />)}
        {items.slice(1, 2).map((it) => <Item key={it.to} it={it} loc={loc} />)}
        <a href={waLink(s)} target="_blank" rel="noreferrer" data-testid="bottomnav-whatsapp" className="flex flex-col items-center justify-center py-2.5 gap-1 text-[#25D366]">
          <i className="fa-brands fa-whatsapp text-lg" />
          <span className="text-[0.58rem] tracking-widest">WHATSAPP</span>
        </a>
        {items.slice(2).map((it) => <Item key={it.to} it={it} loc={loc} />)}
      </div>
    </nav>
  );
}

function Item({ it, loc }) {
  const active = loc.pathname === it.to;
  const Icon = it.icon;
  return (
    <Link to={it.to} data-testid={`bottomnav-${it.label.toLowerCase()}`} className={`flex flex-col items-center justify-center py-2.5 gap-1 ${active ? "text-gold" : "text-ivory/75"}`}>
      <Icon className="w-[18px] h-[18px]" />
      <span className="text-[0.58rem] tracking-widest">{it.label}</span>
    </Link>
  );
}
